import * as utils from "common/utils";
import Watermark from "components/Watermark";
import { HelpTooltip } from "components/Help";
import { useAnalysisResults } from "containers/BudgetHome";

export default function DairyNZFarmSystemType({ analysis}) {
    const dairyNZFarmSystemType = useDairyNZFarmSystemType(analysis);
    if (!dairyNZFarmSystemType) {
        return null;
    }

    return (
        <>
            <div className="Table">
                <Watermark />
                <table>
                    <thead>
                        <tr>
                            <th data-width="20">&nbsp;</th>
                            <th data-width="32.5">
                                System type
                                <HelpTooltip tip={dairyNZFarmSystemType.systemType.description} />
                            </th>
                            <th data-width="32.5">Diet from imported feed (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="u-textBold">DairyNZ farm system type</td>
                            <td id="dairynz_farm_system_type">System {dairyNZFarmSystemType.systemType.value}</td>
                            <td id="diet_from_imported_feed">{utils.numeric.formatAllowZeroWithUnit(dairyNZFarmSystemType.percentageOfDietFromImportedFeed, 1)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}

function useDairyNZFarmSystemType(analysis) {
    const { data: analysisResults } = useAnalysisResults(analysis);
    if (analysisResults?.animals) {
        const dairyEnterprise = analysis?.enterprises?.find(e => e.type === "Dairy");
        if (!dairyEnterprise)
            return null;

        const data = {
            systemType: analysisResults?.animals?.production?.dairy?.farmSystemType,
            percentageOfDietFromImportedFeed: analysisResults?.animals?.diet?.byEnterprise?.find((e) => e.id === dairyEnterprise.id)?.percentageOfDietFromImportedFeed
        };
        return data
    }
}
